<ifc-app-scroll-container class="ifc-app-scroll-container-center">
  <div class="content">
    <form [formGroup]="form" class="form">
      <mat-form-field appearance="outline">
        <mat-label>Loan Number</mat-label>
        <input matInput type="text" formControlName="loanNumber" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Legal entity name</mat-label>
        <input matInput type="text" formControlName="businessName" />
      </mat-form-field>

      <table mat-table [dataSource]="subtransactions" class="table">
        <ng-container matColumnDef="index">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let _; let i = index">{{ i + 1 }}</td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef>Transaction type</th>
          <td mat-cell *matCellDef="let element">
            {{ getTypeName(element.type) }}
          </td>
          <td mat-footer-cell *matFooterCellDef>
            <strong>Total</strong>
          </td>
        </ng-container>

        <ng-container matColumnDef="amount">
          <th mat-header-cell *matHeaderCellDef>Amount</th>
          <td mat-cell *matCellDef="let element">
            {{ element.amount | currency: 'USD' : 'symbol' }}
          </td>
          <td mat-footer-cell *matFooterCellDef>
            {{ transaction?.displayAmount | currency: 'USD' : 'symbol' }}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
      </table>

      <div class="note" *ngIf="transaction?.customerNote">
        <span class="note__secondary">{{ transaction?.initiator }} wrote a note</span>
        <span>{{ transaction?.customerNote.text }}</span>
        <span class="note__secondary">{{ transaction?.date | date: 'medium' }}</span>
      </div>

      <mat-form-field appearance="outline">
        <mat-label>Status</mat-label>
        <input matInput type="text" formControlName="status" />
      </mat-form-field>

      <mat-form-field appearance="outline" *ngIf="transaction?.failureReasons && transaction?.failureReasons?.length > 0" [matTooltip]="form.get('failureReasons')?.value">
        <mat-label>Reject / Pending reasons</mat-label>
        <input matInput type="text" formControlName="failureReasons">
      </mat-form-field>
    </form>

    <ifc-app-card-one-column>
      <ifc-simple-horizontal-list-widget
        title="Transfer details"
        [listItems]="listData"
        [config]="listWidgetConfig"
      ></ifc-simple-horizontal-list-widget>
    </ifc-app-card-one-column>
  </div>
</ifc-app-scroll-container>
